// FILE: src/blueprint/components/insights/CoachHeader.jsx
/**
 * GOAL:
 * - Render the coach identity once at the top of the coach stream.
 * - Show avatar image, coach name, and optional slogan.
 *
 * IMPORTANT:
 * - This component is purely visual.
 * - No typing or queue behavior lives here.
 */

export default function CoachHeader({
  name = 'Coach',
  slogan = '',
  avatarSrc = '',
  avatarText = 'C',
  className = '',
}) {
  const rootClassName = ['digivibe-coach-header', className].filter(Boolean).join(' ');

  return (
    <div className={rootClassName}>
      <div className="digivibe-coach-header__avatar">
        {avatarSrc ? (
          <img src={avatarSrc} alt={name} className="digivibe-coach-header__avatar-image" />
        ) : (
          <span className="digivibe-coach-header__avatar-fallback">{avatarText}</span>
        )}
      </div>

      <div className="digivibe-coach-header__meta">
        <div className="digivibe-coach-header__name">{name}</div>

        {slogan ? <div className="digivibe-coach-header__slogan">{slogan}</div> : null}
      </div>
    </div>
  );
}
